import React from 'react';
import { Link } from 'react-router-dom';
import './PageBanner.css';

const PageBanner = ({ badge, title, highlight, subtitle, breadcrumb }) => {
  return (
    <div className="page-banner-section">
      <div className="page-banner-glow"></div>
      <div className="page-banner-container">
        {badge && (
          <div className="page-banner-badge">
            <span className="page-banner-dot"></span>
            <span>{badge}</span>
          </div>
        )}
        <h1 className="page-banner-title">
          {title} {highlight && <span className="title-gradient">{highlight}</span>}
        </h1>
        {subtitle && <p className="page-banner-subtitle">{subtitle}</p>}
        
        {breadcrumb && (
          <nav className="page-banner-breadcrumb" aria-label="breadcrumb">
            <Link to="/" className="breadcrumb-link">Home</Link>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">{breadcrumb}</span>
          </nav>
        )}
      </div>
    </div>
  );
};

export default PageBanner;
